export function timeToString(ms: number, delim = ':'): string {
    if (ms < 1000) {
        ms = 1000;
    }
    const showWith0 = (value: number): string =>
        value < 10 ? `0${value}` : `${value}`;
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const seconds = showWith0(Math.round((ms / 1000) % 60));

    return `${minutes}${delim}${seconds}`;
}
